import { render, staticRenderFns } from "./SpecificationApproval.vue?vue&type=template&id=45b3146f"
import script from "./SpecificationApproval.vue?vue&type=script&lang=js"
export * from "./SpecificationApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports